import { render, staticRenderFns } from "./Folders3.vue?vue&type=template&id=77e2004e&scoped=true"
import script from "./Folders3.vue?vue&type=script&lang=js"
export * from "./Folders3.vue?vue&type=script&lang=js"
import style0 from "./Folders3.vue?vue&type=style&index=0&id=77e2004e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e2004e",
  null
  
)

export default component.exports